import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	playlists: [],
	playlist: null,

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,
	changeFormat: false,
	changeQuality: false,

	todayTotal: 0,
	todayWhitelisted: 0,
	todayBlacklisted: 0,
	todayFound: 10,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const PlaylistSlice = createSlice({
	name: 'playlist',
	initialState,
	reducers: {

		clearPlaylistItem: (state, action) => {
			return { ...state, playlist: null };
		},

		// Loading
		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},
		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},
		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},
		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},
		onLoadItem: (state, action ) => {
			return {...state, gettingItem: true};
		},
		onLoadFormat: (state, action ) => {
			return {...state, changeFormat: true};
		},
		onLoadQuality: (state, action ) => {
			return {...state, changeQuality: true};
		},

		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},
		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},
		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},
		onSuccessList: (state, action) => {
			return {
				...state,
				playlists: action.payload.data.data,
				gettingList: false,
				todayTotal: action.payload.data.todayTotal,
				todayWhitelisted: action.payload.data.todayWhitelisted,
				todayBlacklisted: action.payload.data.todayBlacklisted,
				todayFound: action.payload.data.todayFound,
			};
		},
		onSuccessItem: (state, action) => {
			return {...state, playlist: action.payload.data, gettingItem: false};
		},
		onSuccessFormat: (state, action) => {
			return {...state, playlist: action.payload.data, changeFormat: false};
		},
		onSuccessQuality: (state, action) => {
			return {...state, playlist: action.payload.data, changeQuality: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},
		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},
		onFailList: (state, action) => {
			return {...state, playlists: [] };
		},
		onFailItem: (state, action) => {
			return {...state, playlist: null };
		},
		onFailFormat: (state, action) => {
			return {...state, playlist: null, changeFormat: false };
		},
		onFailQuality: (state, action) => {
			return {...state, playlist: null, changeQuality: false };
		},
	},
});

export const {
	clearPlaylistItem,
} = PlaylistSlice.actions;
